import { Injectable, computed } from '@angular/core';
import { HttpClient, httpResource } from '@angular/common/http';
import { Observable } from 'rxjs';

import { apiEndpoints } from '../app/configs/api-endpoints.config';
import { KomplexumVmForList, KomplexumVmForDetail } from '../models/komplexum.model';
import { HelysegVmForList } from "../models/helyseg.model";

@Injectable({
    providedIn: 'root',
})
export class KomplexumService {
    private komplexumEndpointUrl = apiEndpoints.komplexum;

    private komplexumResource = httpResource<KomplexumVmForList[]>(() => ({
        url: this.komplexumEndpointUrl
    }));

    readonly komplexumok = computed((): KomplexumVmForList[] =>
        this.komplexumResource.value() ?? []
    );
    readonly loading = computed(() => this.komplexumResource.isLoading());
    readonly error = computed(() => this.komplexumResource.error()?.message ?? null);

    constructor(private http: HttpClient) {}

    reload(): void {
        this.komplexumResource.reload();
    }

    getKomplexumById(komplexumId: number): Observable<KomplexumVmForDetail> {
        return this.http.get<KomplexumVmForDetail>(`${this.komplexumEndpointUrl}/${komplexumId}`);
    }

    getHelysegek(komplexumId: number): Observable<HelysegVmForList[]> {
        return this.http.get<HelysegVmForList[]>(`${this.komplexumEndpointUrl}/${komplexumId}/helyseg`);
    }
}
